import { sortBy } from 'lodash';

export default {
  getSupplier: (state) => state.supplier,
  suppliers: (state) => sortBy(state.suppliers, 'name'),
};
